import * as React from 'react';
import RoutePrivate from 'src/components/router/RoutePrivate';
import ReportDashboardPage from './ReportDashboardPage';

export default function getRoutes(isLoggedIn: boolean) {
    return [
        <RoutePrivate key="reports-dashboard" path="/reports" component={ReportDashboardPage} isLoggedIn={isLoggedIn} />,
    ];
}



// WEBPACK FOOTER //
// ./src/components/reports/Reports.Routes.tsx